module.exports = __webpack_public_path__ + "img/guanyuwomen.dbcca52f.png";